import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useCrudForm } from "../common/crudForm/useCrudForm";
import { CrudFormLayout, Field } from "../common/crudForm/crudFormLayout";
import { useAuth } from "../../AuthContext";
import { getCategoria, saveCategoria } from "../../services/categoriasService";
import { getConfig } from "../../config/config.js";
import _ from "lodash";
import RoundButton from "../common/roundButton";
import ChildPagination from "../common/childPagination";
import ReactTabHotkeyReplacer from "react-tab-hotkey-replacer";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Input from "../common/input";

import Joi from "joi";

// export default function CondicionesIvaForm({ initialData = { nombre: "", documento: "" }, onCancel }) {
export default function CategoriasForm(props) {
  const history = useHistory();
  const { activeUser, permisos: allowedTo } = useAuth();

  const [childIndex, setChildIndex] = useState(0);
  const [child, setChild] = useState({ descripcion: "" });
  const [childAction, setChildAction] = useState("");
  const [childPage, setChildPage] = useState(1);
  const [show, setShow] = useState(false);
  const onCancel = props.onCancel;
  const title = "Categoría";
  const subTitle = "Detalles";
  const initialData = { descripcion: "", rubros: [] };

  const config = getConfig();
  const childRecordsPerPage = config.childRecordsPerPage;

  const breadcrumbs = [
    {
      title: "Inicio",
      link: "/main",
    },
    {
      title: "Categorías",
      link: "/categorias",
    },
    {
      title: "Detalles",
    },
  ];

  const schema = Joi.object({
    _id: Joi.string(),
    descripcion: Joi.string().label("Descripción").required().messages({
      "string.empty": "Debe ingresar una descripción",
    }),
  });

  const hookFetchData = async (id) => {
    try {
      const record = await getCategoria(id);
      return record;
    } catch {
      history.replace("/noconnection");
    }
  };

  const onSave = async (data) => {
    // try {
    const savedRecord = await saveCategoria(data);
    return savedRecord;
    // } catch (error) {
    //   throw error; // Rethrow the error to be handled by the caller
    // }
  };

  const crudForm = useCrudForm({
    defaultPath: "/categorias",
    initialData,
    onSave,
    schema: schema,
    onLoading: props.onLoading,
    onDoneLoading: props.onDoneLoading,
    hookFetchData,
    liveValidate: true,
  });

  // --- Overridden submit handler ---
  const handleSubmit = async (e) => {
    e.preventDefault();

    // // 1. Custom pre-processing the base hook doesn't know about.
    // if (crudForm.data.year && Number(crudForm.data.year) > new Date().getFullYear() + 1) {
    //   crudForm.setErrors({ year: "Year can't be in the future." });
    //   return;
    // }

    // 2. Delegate to the base implementation (the "super" call).
    const ok = await crudForm.submit();

    // 3. Custom post-processing, only if the save succeeded.
    if (ok) {
      // console.log("[analytics] car_saved", crudForm.data.make, crudForm.data.model);
      // alert("Car saved!");
    }
  };

  const handleClose = () => {
    setShow(false);
  };

  const handleShow = (status) => {
    const child = { ...crudForm.data };
    if (status === "A") {
      child.descripcion = "";
    }
    setShow(true);
    setChild(child);
    setChildAction(status);
  };

  const handleChildPageChange = (newPage) => {
    let childPage = newPage;
    if (newPage < 1) childPage = 1;
    if (newPage > totalPages) childPage = totalPages;
    setChildPage(childPage);
  };

  const handleSaveChild = () => {
    // const { child, childAction } = this.state;
    let rubros = [...crudForm.data.rubros];
    let data = { ...crudForm.data };
    if (childAction === "A") {
      rubros.push(child);
    }
    if (childAction === "M") {
      rubros[childIndex].descripcion = child.descripcion;
    }
    const ordered = _.orderBy(rubros, (item) => item.descripcion.toLocaleUpperCase(), "asc");
    data.rubros = ordered;
    crudForm.setData(data);
    setChildAction("");
    setChild({ descripcion: "" });
    setShow(false);
  };

  const handleChildChange = ({ currentTarget: input }) => {
    let child = { ...crudForm.child };
    child.descripcion = input.value;
    setChild(child);
  };

  const handleChildEdit = (index) => {
    const { rubros } = crudForm.data;
    setShow(true);
    setChildAction("M");
    setChild({ descripcion: rubros[index].descripcion });
    setChildIndex(index);
  };

  const handleChildDelete = (index) => {
    let rubros = [...crudForm.data.rubros];
    rubros.splice(index, 1);
    let data = { ...crudForm.data };
    data.rubros = rubros;
    crudForm.setData(data);
  };

  const { rubros } = crudForm.data;
  const ordered = _.orderBy(rubros, (item) => item.descripcion.toLocaleUpperCase(), "asc");
  const childRecords = ordered.slice((childPage - 1) * childRecordsPerPage, childPage * childRecordsPerPage);
  const totalPages = Math.ceil(childRecords.length / childRecordsPerPage);

  return (
    <CrudFormLayout
      crudForm={crudForm}
      title={title}
      subTitle={subTitle}
      breadcrumbs={breadcrumbs}
      onSubmit={handleSubmit} // note: our override, not crud.handleSubmit
      onCancel={onCancel}
      // onGoBack={crudForm.goBack}
      // loading={crudForm.loading}
      // errors={crudForm.errors}
      submitLabel="Guardar"
    >
      <div className="row ">
        <Field crudForm={crudForm} label="Descripción" name="descripcion" float="true" columns="6" autoFocus={true} />
      </div>
      <div className="row ">
        <div className="col-8">
          {/* <label htmlFor="tableRubros" className="form-label">
                            Rubros
                          </label> */}
          <table id="tableRubros" className="table table-sm table-hover centered-header">
            <thead className="thead-light">
              <tr>
                <th width="90%">Rubros</th>
                <th width="5%"></th>
                <th width="5%">
                  {crudForm.action !== "C" && (
                    <RoundButton
                      onClick={() => handleShow("A")}
                      iconClass="fas fa-plus black"
                      className="btn-transparent "
                      tooltip="Nuevo Rubro"
                    />
                  )}
                </th>
              </tr>
            </thead>

            <tbody>
              {childRecords.map((rubro, index) => {
                return (
                  <tr key={`rubro${index}`}>
                    <td>{rubro.descripcion}</td>
                    <td>
                      {crudForm.action !== "C" && (
                        <i
                          className="fas fa-pencil-alt text-info mr-2 clickable"
                          data-toggle="modal"
                          data-target="#modal-default"
                          onClick={() => handleChildEdit(index)}
                        ></i>
                      )}
                    </td>
                    <td>
                      {crudForm.action !== "C" && (
                        <i
                          className="fas fa-trash-alt text-danger mr-2 clickable"
                          onClick={() => handleChildDelete((childPage - 1) * childRecordsPerPage + index)}
                        ></i>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          <ChildPagination
            onPageChange={(page) => handleChildPageChange(page)}
            itemsCount={rubros.length}
            pageSize={childRecordsPerPage}
            currentPage={childPage}
          />
        </div>
        <Modal show={show} onHide={handleClose}>
          <Modal.Header>
            <Modal.Title>
              <strong>Rubro</strong>
            </Modal.Title>
            <button type="button" className="close" onClick={handleClose}>
              <span aria-hidden="true">×</span>
              <span className="sr-only">Cerrar</span>
            </button>
          </Modal.Header>
          <Modal.Body>
            <ReactTabHotkeyReplacer>
              <Input
                name="descripcionRubro"
                label="Descripción"
                float
                columns="8"
                newRow
                autoFocus
                onChange={handleChildChange}
                value={child.descripcion}
              />
            </ReactTabHotkeyReplacer>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cerrar
            </Button>
            <Button variant="secondary" onClick={handleSaveChild}>
              Guardar
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </CrudFormLayout>
  );
}
